<template>
  <div>
    <box-header title="分布式光伏发电">
      <div class="box-header-tab">
        <div @click="changeType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
        <div @click="changeType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
      </div>
    </box-header>
    <div class="box" style="height: 420px;background: rgba(7,17,32,.3);">
      <box-border line></box-border>
      <div class="box-filter">
        <div class="box-count">
          <span class="count-name">总量：</span>
          <span class="count-value">{{ count }}</span>
          <span class="count-unit">kwh</span>
        </div>
        <div v-if="type === 'year'" class="box-select">
          <el-select :value="currentYear" @change="changeYear" placeholder="请选择">
            <el-option
                v-for="(year,index) in yearList"
                :key="index"
                :value="year"
                :label="year + '年'"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="type === 'month'" class="box-select">
          <el-select :value="currentMonth" @change="changeMonth" placeholder="请选择">
            <el-option
                v-for="(month,index) in monthList"
                :key="index"
                :value="month"
                :label="month + '月'">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="height: calc(100% - 80px)">
        <div id="ChartXLTJ_Photovoltaic" class="chart"></div>
      </div>
    </div>
    <Photovoltaic_Detail ref="Photovoltaic_Detail"/>
  </div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
import Photovoltaic_Detail from "./Photovoltaic_Detail.vue";

const yearMonthList = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export default {
  name: "ChartXLTJ_Photovoltaic",
  components: {Photovoltaic_Detail, BoxBorder, BoxHeader},
  data() {
    return {
      name: "充电站销量统计",
      type: "month",
      yearList: ["2026","2025","2024","2023", "2022", "2021"],
      currentYear: "",
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      currentMonth: "",
      sectionData:[],
      newDataList:[],
      dateCateGory:[],
      category: [],
      data:[],
      max: 0,
      count: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      const time = new Date();
      this.currentYear =  time.getFullYear() +"";
      this.currentMonth = time.getMonth() + 1;
      this.chart = this.$echarts.init(document.getElementById("ChartXLTJ_Photovoltaic"));
      this.bindEvents();
      this.getData();
    });
  },
  methods: {
    bindEvents() {
      this.chart.on("click", (data) => {
        if (this.type === "year") {
          return false;
        }
        let day = this.category[data.dataIndex];
        if (day) {
          day = parseInt(day);
        }
        const date = this.currentYear + '-' + this.$util.padStartInt(this.currentMonth,2) + '-' + this.$util.padStartInt(day,2);
        this.$refs.Photovoltaic_Detail.open({date});
      });
    },
    getData() {
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)"
      });

      if(this.type === 'year'){
        const param = { "year" : this.currentYear}
        this.$api.getStationStatisticsByYear(param).then(res => {
          this.disposeData(res.data);
        });
      }

      if(this.type === 'month'){
        const param = { "year" : this.currentYear, "month" : this.currentMonth }
        this.$api.getStationStatisticsByMonth(param).then(res=>{
          this.disposeData(res.data);
        })
      }
    },
    disposeData(sourceData) {
      sourceData.sort((a, b) => new Date(a.time) - new Date(b.time));
      let dateList = sourceData.map(item=>item.time);
      if(this.type === 'month'){
        this.category = sourceData.map(item => {
          let day = item.time.split('-')[2];
          if (day.startsWith("0")) {
            day = day.replace("0", "");
          }
          return `${day}日`; // 转换为 "13日"
        });
      }else{
        this.category = yearMonthList;
        if (this.data.length < 12) {
          for (let i = 0; i < 12; i++) {
            if (!this.data[i]) this.data.push(0);
          }
        }
      }
      this.dateCateGory = dateList;
      this.data = sourceData.map(item => item.kwh);
      this.count = this.$lodash.sum(this.data).toFixed(2);
      this.max = this.$util.formatInt(this.$lodash.max(this.data) + 100, 2);
      this.renderChart();
    },
    renderChart() {
      this.chart.hideLoading();
      const barWidth = 30;
      const colorArr = ["#e8c547", "#d4a017", "#fff1a8"];
      const color = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[1],
          },
          {
            offset: 1,
            color: colorArr[1],
          },
        ],
      };

      let options = {
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: "<div class='title'>{a0}</div><div class='name'>{b0}</div><div class='value'>{c0}<span class='unit'>kwh</span></div>",
          textStyle: {
            fontSize: 30,
          },
        },
        grid: {
          top: 45,
          bottom: 30,
          left: 30,
          right: 50,
          containLabel: true,
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true,
        }],
        xAxis: {
          type: "category",
          data: this.category,
          splitNumber: 6.5,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          boundaryGap: true,
        },
        yAxis: {
          type: "value",
          name: "kwh",
          nameLocation: "end",
          nameGap: 25,
          nameTextStyle: {
            fontSize: 22,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .6)",
          },
          min: 0,
          max: this.max,
          minInterval: 1000,
          splitNumber: 5,
          axisLabel: {
            margin: 25,
            fontSize: 24,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .8)",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
        },
        series: [
          {
            z: 1,
            name: "光伏发电统计",
            type: "bar",
            barWidth: barWidth,
            data: this.data,
            itemStyle: {
              normal: {
                color: color,
              },
            },
            label: {
              show: false,
              position: "top",
              distance: 20,
              fontSize: 16,
              fontFamily: "screen",
              color: "#F89E85",
            },
            emphasis: {
              label: {
                fontSize: 18,
              },
            },
            animation: true,
          },
          {
            z: 2,
            name: "LNG销量统计",
            type: "pictorialBar",
            data: this.sectionData,
            symbol: "diamond",
            symbolOffset: [0, "50%"],
            symbolSize: [barWidth, 10],
            itemStyle: {
              normal: {
                color: color,
              },
            },
            animation: true,
          },
          {
            z: 3,
            name: "LNG销量统计",
            type: "pictorialBar",
            symbolPosition: "end",
            data: this.data,
            symbol: "diamond",
            symbolOffset: [0, "-56%"],
            symbolSize: [barWidth + 1, 10],
            itemStyle: {
              normal: {
                borderWidth: 2,
                color: colorArr[2],
              },
            },
            animation: true,
          },

        ],
      };

      this.chart.setOption(options);
      this.chart.dispatchAction({
        type: "dataZoom",
        startValue: this.data.length - 11,
        endValue: this.data.length
      });
    },
    changeType(type) {
      let time = new Date();
      this.currentMonth = time.getMonth() + 1 +"";
      this.type = type;
      this.getData();
    },
    changeYear(year) {
      this.currentYear = year;
      this.getData();
    },
    changeMonth(month) {
      this.currentMonth = month;
      this.getData();
    }
  }
};
</script>

<style scoped lang="scss">
.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;

  .tab-item {
    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 25px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }

    &.disabled {
      cursor: no-drop;
    }
  }
}

.box-filter {
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
  padding-bottom: 0;
  box-sizing: border-box;
  height: 90px;
}

.box-count {
  height: 60px;
  line-height: 60px;

  .count-name {
    font-size: 28px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 32px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 22px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
